import { Routes, Route } from 'react-router-dom'
import { Login, Dashboard, Realtime, Operators, OperatorDetail, Alerts, Users } from '@/pages'
import { Layout, ProtectedRoute } from '@/components'
import { WebSocketProvider } from '@/context/WebSocketContext'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <WebSocketProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/realtime" element={<Realtime />} />
                  <Route path="/operators" element={<Operators />} />
                  <Route path="/operators/:machineId" element={<OperatorDetail />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/reports" element={<PlaceholderPage title="Rapports" />} />
                  <Route path="/settings" element={<PlaceholderPage title="Paramètres" />} />
                </Routes>
              </Layout>
            </WebSocketProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">{title}</h1>
      <p className="text-gray-600">Cette page sera implémentée dans les prochaines phases.</p>
    </div>
  )
}

export default App
